<template>
    <div class="TimelineHolder">
        <div id="Timeline">
            <div class="timeline-events">
                <div data-timeline-node="{ eventId:1, start:'2019-01-05 05:30',row:2,bdColor:'#942343',image:'./imgs/sample-1.jpg' }">
                    Event Relation 1
                </div>
                <!-- <div data-timeline-node="{ eventId:2, start:'2020-02-15 00:00',row:2,margin:12,bdColor:'#942343',relation:{after:3} }">
                    Event Relation 2
                </div>
                <div data-timeline-node="{ eventId:3, start:'2020-02-17 12:30',row:2,margin:12,bdColor:'#942343',relation:{after:4},content:'<h2>2016</h2><a href=\'http://www.blic.rs\' target=\'_blank\'>Otvori Blic</a><p>Otvaranje stranice u novom tabu</p>' }">
                    Relational Event (ID:3)
                </div>
                <div data-timeline-node="{ eventId:4, start:'2020-02-19 8:40',row:2,margin:12,bdColor:'#942343' }">
                    Event Relation 4
                </div>
                <div data-timeline-node="{ eventId:5, start:'2017-7-14 17:30',row:2,margin:12,bdColor:'#942343',relation:{before:4} }">
                    Event Relation 5
                </div>
                <div data-timeline-node="{ eventId:6, start:'2017-9-26 18:30',row:2,margin:12,bdColor:'#942343',relation:{before:5,after:-1} }">
                    Event Relation 6
                </div>
                <label>Row 3</label>
                <div data-timeline-node="{ eventId:7, start:'2016-9-26 7:00',row:3,image:'./imgs/sample-2.jpg',extend:{toggle:'popover',placement:'top',content:'It is also possible to bind external custom events.'} }">
                    Event Relation 7
                </div>
                <div data-timeline-node="{ eventId:8, start:'2016-11-9 8:30',row:3,margin:12,relation:{before:7} }">
                    Event Relation 8
                </div>
                <div data-timeline-node="{ eventId:9, start:'2017-1-25 11:15',row:3,margin:12,relation:{before:8} }">
                    Event Relation 9
                </div>
                <div data-timeline-node="{ eventId:10, start:'2017-4-7 14:10',row:3,margin:12,relation:{before:9,after:5} }">
                    Event Relation 10
                </div>
                <label>Row 4 - 6</label>
                <div data-timeline-node="{ eventId:11, start:'2016-10-15 0:00',row:6,bdColor:'#37a34a',image:'./imgs/sample-3.jpg',relation:{after:12,linesize:10} }">
                    Event Relation 11
                </div>
                <div data-timeline-node="{ eventId:12, start:'2017-2-4 17:00',row:6,bdColor:'#37a34a',image:'./imgs/sample-4.jpg' }">
                    Event Relation 12
                </div>
                <div data-timeline-node="{ eventId:13, start:'2016-8-11 22:00',row:5,bdColor:'#6f5436',image:'./imgs/sample-5.jpg',relation:{before:-1,after:11,curve:'rt'} }">
                    Event Relation 13
                </div>
                <div data-timeline-node="{ eventId:14, start:'2016-8-31 2:00',row:4,bdColor:'#dc6b9a',image:'./imgs/sample-6.jpg',relation:{before:-1,after:7,linecolor:'#5a4498',curve:'rb'} }">
                    Event Relation 14
                </div>
                <div data-timeline-node="{ eventId:15, start:'2016-12-24 10:00',row:4,bdColor:'#dc6b9a',image:'./imgs/sample-7.jpg',relation:{before:8,linecolor:'#5a4498',curve:'lb'} }">
                    Event Relation 15
                </div>
                <div data-timeline-node="{ eventId:16, start:'2017-8-11 20:00',row:5,bdColor:'#6f5436',image:'./imgs/sample-8.jpg',relation:{before:12,after:-1,curve:'lt'} }">
                    Event Relation 16
                </div> -->
            </div>
        </div>
        <div class="timeline-event-view"></div>

        <div>
                  <span class="kvaka">
                    <v-icon slot="activator" class="ml-2" @click="doSomething" title="Ucitaj timeline">fa-save</v-icon>
                  </span>
                </div>
                <TokenComponent ref="frmtoken"/>
    </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";

    import jQuery from "jquery";
import TokenComponent from "../components/Token";

    global.jQuery = jQuery;

    let timeline = require("./../plugins/timeline/timeline.min.js");
    require("./../plugins/timeline/timeline.min.css");

    export default {
        name: "Timeline",
        props: {},
        components: {
      TokenComponent
    },
  data() {
    return {
        tank_phase_vineId: 0,
        items_timeline: []
    }
  },
  methods: {
      getDataForTimeline() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/wine/tank_phase_wine/" +
            this.tank_phase_vineId + "/timeline", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
        )
        .then(response => {
            // console.log(response.data);

          this.items_timeline = response.data;

jQuery("#Timeline").timeline({
                    type: "point",
                    scale: "months",
                    startDatetime: this.items_timeline[0].start.split("T")[0],
                    range: 2,
                    rows: 15,
                    datetimeFormat: {meta: "g:i A, D F j, Y"},
                    rangeAlign: "center"
                });
                
                // this.doSomething();
        })
        .catch(e => {
          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/wine/tank_phase_wine/" +
            this.tank_phase_vineId + "/timeline", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
        )
        .then(response => {
            // console.log(response.data);

          this.items_timeline = response.data;

jQuery("#Timeline").timeline({
                    type: "point",
                    scale: "months",
                    startDatetime: this.items_timeline[0].start.split("T")[0],
                    range: 2,
                    rows: 15,
                    datetimeFormat: {meta: "g:i A, D F j, Y"},
                    rangeAlign: "center"
                });
                
                // this.doSomething();
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
  	doSomething(){
          
let i;
let arrayTimeline = [];

for (i = 0; i < this.items_timeline.length; i++) {
  let elemTimeline;
  
  let boja = "";
  
  switch(this.items_timeline[i].row % 8) {
  case 1:
    boja = "#942343";

    break;
  case 2:
    boja = "#ff3333";

    break;
  case 3:
    boja = "#5c5cd6";

    break;
  case 4:
    boja = "#00cc00";
    
    break;
  case 5:
    boja = "#cc9966";

    break;
  case 6:
    boja = "#bf80ff";

    break;
  case 7:
    boja = "#c65353";

    break;
  default:
    boja = "#ffff4d";
}
    
  if (this.items_timeline[i].relation.after === null )
    if (this.items_timeline[i].relation.before === null )
        elemTimeline = {eventId: this.items_timeline[i].eventId + 1, callback:'$.openMyEvent()', extend:{'prop':this.items_timeline[i].content}, start: this.items_timeline[i].start.replace('T', ' '), end: this.items_timeline[i].start.replace('T', ' '),row: this.items_timeline[i].row, bdColor: boja, label:'Event ' + this.items_timeline[i].eventId, content: this.items_timeline[i].content, image:"../imgs/dodavanje.svg"};
    else
        if (this.items_timeline[i].relation.curve === null )
            elemTimeline = {eventId: this.items_timeline[i].eventId + 1, callback:'$.openMyEvent()', extend:{'prop':this.items_timeline[i].content}, start: this.items_timeline[i].start.replace('T', ' '), end: this.items_timeline[i].start.replace('T', ' '),row: this.items_timeline[i].row, bdColor: boja, label:'Event ' + this.items_timeline[i].eventId, content: this.items_timeline[i].content, image:"../imgs/dodavanje.svg", relation:{before: this.items_timeline[i].relation.before + 1} };
        else
            elemTimeline = {eventId: this.items_timeline[i].eventId + 1, callback:'$.openMyEvent()', extend:{'prop':this.items_timeline[i].content}, start: this.items_timeline[i].start.replace('T', ' '), end: this.items_timeline[i].start.replace('T', ' '),row: this.items_timeline[i].row, bdColor: boja, label:'Event ' + this.items_timeline[i].eventId, content: this.items_timeline[i].content, image:"../imgs/dodavanje.svg", relation:{before: this.items_timeline[i].relation.before + 1, curve: this.items_timeline[i].relation.curve} };
  else
    if (this.items_timeline[i].relation.before === null )
        if (this.items_timeline[i].relation.curve === null )
            elemTimeline = {eventId: this.items_timeline[i].eventId + 1, callback:'$.openMyEvent()', extend:{'prop':this.items_timeline[i].content}, start: this.items_timeline[i].start.replace('T', ' '), end: this.items_timeline[i].start.replace('T', ' '),row: this.items_timeline[i].row, bdColor: boja, label:'Event ' + this.items_timeline[i].eventId, content: this.items_timeline[i].content, relation:{after: this.items_timeline[i].relation.after + 1} };
        else
            elemTimeline = {eventId: this.items_timeline[i].eventId + 1, callback:'$.openMyEvent()', extend:{'prop':this.items_timeline[i].content}, start: this.items_timeline[i].start.replace('T', ' '), end: this.items_timeline[i].start.replace('T', ' '),row: this.items_timeline[i].row, bdColor: boja, label:'Event ' + this.items_timeline[i].eventId, content: this.items_timeline[i].content, relation:{after: this.items_timeline[i].relation.after + 1, curve: this.items_timeline[i].relation.curve} };
    else
        if (this.items_timeline[i].relation.curve === null )
            elemTimeline = {eventId: this.items_timeline[i].eventId + 1, callback:'$.openMyEvent()', extend:{'prop':this.items_timeline[i].content}, start: this.items_timeline[i].start.replace('T', ' '), end: this.items_timeline[i].start.replace('T', ' '),row: this.items_timeline[i].row, bdColor: boja, label:'Event ' + this.items_timeline[i].eventId, content: this.items_timeline[i].content, relation:{before: this.items_timeline[i].relation.before + 1, after: this.items_timeline[i].relation.after + 1} };
        else
            elemTimeline = {eventId: this.items_timeline[i].eventId + 1, callback:'$.openMyEvent()', extend:{'prop':this.items_timeline[i].content}, start: this.items_timeline[i].start.replace('T', ' '), end: this.items_timeline[i].start.replace('T', ' '),row: this.items_timeline[i].row, bdColor: boja, label:'Event ' + this.items_timeline[i].eventId, content: this.items_timeline[i].content, relation:{before: this.items_timeline[i].relation.before + 1, after: this.items_timeline[i].relation.after + 1, curve: this.items_timeline[i].relation.curve} };
  
  arrayTimeline.push(elemTimeline);
}

// // console.log(arrayTimeline);

jQuery('#Timeline').timeline('addEvent', 
arrayTimeline,
    function( elm, opts, usrdata ){
        // // console.log( usrdata ) // show "Added Events!" in console
    },
    'Added Events!'
);

}
  },
        mounted: function () {
            this.tank_phase_vineId = this.$route.params.id;
            this.getDataForTimeline();


                $.openMyEvent = function() {
  // Retrieve extended data from an opened event 
  alert("Izabrani cvor ima content - " + $('.timeline-node.active').data().prop );

//   // // console.log(this.files.find(file => file.eventId === $('.timeline-node.active').data().relayAfter));
};

// jQuery(function () {
                
//             });
            //this.doSomething();
        }
    };
</script>
